import { render, staticRenderFns } from "./AudioPlayer2.vue?vue&type=template&id=09f21967&scoped=true&"
import script from "./AudioPlayer2.vue?vue&type=script&lang=js&"
export * from "./AudioPlayer2.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayer2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AudioPlayer2.vue?vue&type=style&index=1&id=09f21967&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f21967",
  null
  
)

export default component.exports